import { trpc } from "@/app/router";
import { SalesOrderDetail } from "@/components/pages/inventory/sales-order/sales-order-detail";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute(
	"/_app/inventory/sales-order/_modal/$salesOrderId",
)({
	component: SalesOrderDetailRoute,
});

function SalesOrderDetailRoute() {
	const { salesOrderId } = useParams({
		from: "/_app/inventory/sales-order/_modal/$salesOrderId",
	});

	const {
		data: salesOrder,
		isLoading,
		error,
	} = useQuery(
		trpc.inventory.salesOrder.getById.queryOptions(
			{ salesOrderId },
			{
				staleTime: 10 * 1000, // 10 seconds
				refetchOnWindowFocus: true,
			},
		),
	);

	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-[calc(100vh-200px)]">
				<Loader2 className="h-8 w-8 animate-spin text-primary" />
			</div>
		);
	}

	if (error) {
		return (
			<div className="flex flex-col items-center justify-center h-[calc(100vh-200px)]">
				<h2 className="text-xl font-bold text-red-500">
					Error loading sales order
				</h2>
				<p className="text-gray-600">{error.message}</p>
			</div>
		);
	}

	if (!salesOrder) {
		return (
			<div className="flex flex-col items-center justify-center h-[calc(100vh-200px)]">
				<h2 className="text-xl font-bold">Sales order not found</h2>
				<p className="text-gray-600">
					The requested sales order could not be found
				</p>
			</div>
		);
	}

	return <SalesOrderDetail salesOrder={salesOrder} />;
}
